import React from 'react';

export const RadioGroupContext = React.createContext(undefined);

interface RadioGroupProviderProps {
    selection?: string;
}

interface RadioGroupContextShape extends RadioGroupProviderProps {
    setSelection: (selection: string) => void;
}

export const RadioContext = React.createContext<
    Partial<RadioGroupContextShape>
>({});

export const useRadioContext = () => {
    const value = React.useContext(RadioContext);

    if (value === undefined) {
        throw new Error(
            'useRadioContext must be used within RadioGroupProvider',
        );
    }

    return value;
};

export const RadioGroupProvider: React.FC<React.PropsWithChildren<RadioGroupProviderProps>> = ({ children, selection: initialSelection }) => {
    const [selection, setSelection] = React.useState(initialSelection);

    return (
        <RadioContext.Provider
            value={{
                selection,
                setSelection,
            }}
        >
            <div
                onChange={(event) => {
                    if ((event.target as HTMLInputElement).type === 'radio') {
                        setSelection?.(
                            (event.target as HTMLInputElement).value,
                        );
                    }
                }}
            >
                {children}
            </div>
        </RadioContext.Provider>
    );
};
